const assert = require('@barchart/common-js/lang/assert'),
	is = require('@barchart/common-js/lang/is');

const Transport = require('./../Transport'),
	RegistrationStatus = require('./../RegistrationStatus');

module.exports = (() => {
	'use strict';

	const validator = {
		forQuery: (query, description) => {
			const d = getDescription(description);

			validator.forTarget(query, description);
		},

		forCreate: (query, description) => {
			const d = getDescription(description);

			validator.forTarget(query, description);

			assert.argumentIsRequired(query.status, `${d}.status`, RegistrationStatus, 'RegistrationStatus');
		},

		forTarget: (query, description) => {
			const d = getDescription(description);

			assert.argumentIsRequired(query, d, Object);
			assert.argumentIsOptional(query.application, `${d}.application`, String);
			assert.argumentIsOptional(query.account, `${d}.account`, String);
			assert.argumentIsRequired(query.transport, `${d}.transport`, Transport, 'Transport');
			assert.argumentIsRequired(query.target, `${d}.target`, String);
		}
	};

	function getDescription(description) {
		if (is.string(description)) {
			return description;
		} else {
			return 'registration';
		}
	}

	return validator;
})();
